import { render, staticRenderFns } from "./UpdateStudiesStates.vue?vue&type=template&id=3e937f4e&scoped=true&"
import script from "./UpdateStudiesStates.vue?vue&type=script&lang=js&"
export * from "./UpdateStudiesStates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e937f4e",
  null
  
)

export default component.exports